var _path, _g;
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmailTracking = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 168,
  height: 144,
  fill: "none",
  viewBox: "0 0 168 144",
  ...props,
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: 134,
    height: 88,
    x: 18,
    y: 28,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    },
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M151.765 28.518H18.495v87.247h133.27z"
    }))
  }), _g || (_g = /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#00D639",
      d: "M101.719 67.507H26.215l37.753 22.656z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#00D639",
      d: "M101.719 67.524 69.82 47.584a10.9 10.9 0 0 0-11.532-.013L26.215 67.524z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#C6C6C6",
      d: "M89.46 114.382H61.028L40.957 44.859H69.39z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#ABABAB",
      d: "m80.393 49.335-19.366 65.048h28.435l11.252-37.795L82.529 46.2a6.25 6.25 0 0 0-2.135 3.135"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#303030",
      d: "M18.494 69.972v40.064a5.733 5.733 0 0 0 5.737 5.729h83.327a5.73 5.73 0 0 0 5.736-5.729V69.972a5.73 5.73 0 0 0-5.736-5.728H24.231a5.73 5.73 0 0 0-5.737 5.728m91.346 19.77a2.19 2.19 0 0 1-2.191 2.188 2.19 2.19 0 0 1-2.191-2.188 2.19 2.19 0 0 1 2.191-2.188 2.19 2.19 0 0 1 2.191 2.188m-8.12-22.235v45.314H26.214V67.507z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#474747",
      d: "M18.494 69.972v40.064a5.733 5.733 0 0 0 5.737 5.729h83.327a5.73 5.73 0 0 0 5.736-5.729V69.972a5.73 5.73 0 0 0-5.736-5.728H24.231a5.73 5.73 0 0 0-5.737 5.728m91.346 19.77a2.19 2.19 0 0 1-2.191 2.188 2.19 2.19 0 0 1-2.191-2.188 2.19 2.19 0 0 1 2.191-2.188 2.19 2.19 0 0 1 2.191 2.188m-8.12-22.235v45.314H26.214V67.507z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#474747",
      d: "M109.842 89.869a2.19 2.19 0 0 0-2.063-2.309 2.19 2.19 0 0 0-2.313 2.06 2.19 2.19 0 0 0 2.063 2.309 2.19 2.19 0 0 0 2.313-2.06M63.412 89.832 26.215 67.507v45.314h75.505V67.507L64.523 89.832c-.34.204-.769.204-1.11 0"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#474747",
      d: "M101.719 112.821 64.456 90.457a.95.95 0 0 0-.979 0l-37.262 22.364"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#303030",
      d: "M101.605 113.007 64.343 90.644a.73.73 0 0 0-.756 0l-37.262 22.363-.223-.372 37.262-22.363a1.17 1.17 0 0 1 1.204 0l37.262 22.363-.223.372z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#C6C6C6",
      d: "M112.006 47.945a6.3 6.3 0 0 0-2.127-2.147 6.34 6.34 0 0 0-3.32-.94h-20.16a6.27 6.27 0 0 0-5.075 2.589c.279-.025 1.562-.048 2.806 1.43l16.582 27.71 22.618 37.795h28.435z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "m32.44 72.647-4.493-2.511-2.619 4.422 1.018-5.046-5.01-1.121 5.094-.603-.479-5.107 2.142 4.672 4.74-2.035-3.784 3.468z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#303030",
      d: "M114.784 84.95a3.14 3.14 0 0 1-2.497-2.135l-2.066-6.39a29.7 29.7 0 0 0-4.991-9.326l-6.333-7.996a3.1 3.1 0 0 1-.605-1.276 5.28 5.28 0 0 1 2.297-5.6 5.3 5.3 0 0 1 5.818-.004l9.61 4.97a36.1 36.1 0 0 1 9.153 6.746l7.057 7.168a3.137 3.137 0 0 1-.037 4.44 3.147 3.147 0 0 1-4.446-.038l-7.058-7.168a29.8 29.8 0 0 0-7.561-5.573l-5.604-2.898 2.639 3.334a36 36 0 0 1 6.042 11.292l2.067 6.389a3.14 3.14 0 0 1-2.026 3.951c-.489.158-.986.19-1.46.113z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#777",
      d: "M90.093 33.232a2.15 2.15 0 0 0-1.669-1.458c.18.438.292.736.295.745a1.077 1.077 0 0 1-2.02.748v-.007l-.015-.033-.05-.13a16 16 0 0 0-.186-.467q-.026-.06-.054-.129a2 2 0 0 0-.247.365 2.14 2.14 0 0 0-.168 1.638c.04.129.073.215.112.31.07.175.15.36.248.582.184.414.434.94.741 1.566a168 168 0 0 0 4.652 8.777c.908 1.592 1.827 3.125 2.688 4.433.431.654.85 1.254 1.255 1.785q.303.398.601.747c.2.233.4.449.61.653l.075.064c.311.284.662.52 1.043.702q.397.197.823.323.575.169 1.172.22.082.007.165.01.199.013.399.014.279-.002.557-.035l.066-.009a5.4 5.4 0 0 0 .851-.196q.084-.025.167-.053.445-.157.853-.391a4.6 4.6 0 0 0 1.273-1.073 4.4 4.4 0 0 0 .66-1.095q.13-.301.216-.618c1.225-4.464 2.19-9.053 2.854-12.54.662-3.486 1.022-5.862 1.026-5.882a2.14 2.14 0 0 0-.784-1.998q-.074.369-.121.742a1.076 1.076 0 0 1-1.17.972h-.001a1.06 1.06 0 0 1-.728-.385 1.06 1.06 0 0 1-.242-.786q.047-.436.133-.867a2.15 2.15 0 0 0-1.348 1.678c-.003.017-.357 2.354-1.005 5.761-.166.866-.35 1.803-.552 2.786-.363 1.771-1.776 3.166-3.567 3.44l-.18.024a5.73 5.73 0 0 1-2.953-.426 4.33 4.33 0 0 1-2.091-1.907 178 178 0 0 1-2.605-4.912 99 99 0 0 1-1.283-2.593l-.493-1.096zm9.742 17.003.009.007.011.006.007.007-.146.151.007-.011-.011.011.121-.172z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#474747",
      d: "M92.385 37.03q.126-.31.335-.593a2.675 2.675 0 0 1 3.74-.544l3.836 2.855a2.664 2.664 0 0 1 .545 3.733 2.674 2.674 0 0 1-3.739.545l-3.837-2.856a2.665 2.665 0 0 1-.88-3.14"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#E84D4F",
      d: "M99.267 42.855a1.426 1.426 0 1 0 0-2.85 1.426 1.426 0 1 0 0 2.85"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#474747",
      d: "M97.582 41.065s.878.133 1.63-.098c.895-.276 1.225-.823 1.225-.823l-1.094-.37-1.142.426-.62.865"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#E84D4F",
      d: "M107.105 32.742q-.082 0-.167-.012a1.16 1.16 0 0 1-.983-1.312l.274-1.907a1.16 1.16 0 0 1 2.297.33l-.274 1.907a1.16 1.16 0 0 1-1.147.994M87.85 34.274c-.425 0-.834-.233-1.037-.639l-.867-1.723a1.16 1.16 0 0 1 2.074-1.04l.867 1.723a1.158 1.158 0 0 1-1.037 1.679"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#303030",
      d: "M117.004 84.287a.58.58 0 0 1-.413-.986l2.591-2.625a.58.58 0 1 1 .826.814l-2.591 2.625a.58.58 0 0 1-.413.172M131.762 75.653a.58.58 0 0 1-.414-.987l2.592-2.625a.58.58 0 0 1 .826.814l-2.591 2.626a.58.58 0 0 1-.413.172"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#ABABAB",
      d: "M141.323 104.38h-17.552a.363.363 0 1 1 0-.724h17.552a.363.363 0 0 1 0 .724M132.833 99.693h-12.088a.362.362 0 0 1 0-.724h12.088a.363.363 0 1 1 0 .724M134.504 95.456h-16.267a.362.362 0 1 1 0-.724h16.267a.363.363 0 1 1 0 .724M65.453 49.422H47.902a.362.362 0 1 1 0-.724h17.551a.362.362 0 1 1 0 .724M62.368 53.916H49.316a.362.362 0 1 1 0-.724h13.052a.362.362 0 1 1 0 .724M68.217 73.627H55.165a.362.362 0 1 1 0-.724h13.052a.363.363 0 1 1 0 .724M63.396 78.634h-7.072a.363.363 0 0 1 0-.724h7.072a.362.362 0 1 1 0 .724"
    })]
  }))]
});
export default SvgEmailTracking;